import { HStack, useCss } from '@nettbureau/vibrant-ui';
import { useTranslate } from '@tolgee/react';
import { useContext } from 'react';
import { ConfigContext } from './provider/config-provider';
import { getTheme, getTokenFromVibrant } from './theme';

interface ContactLinkProps {
  url: string;
  color?: string;
}

export function ContactLink({ url, color }: ContactLinkProps) {
  const { globalThemeVariant, theme } = useContext(ConfigContext);

  const { t } = useTranslate();

  const linkStyles = useCss((input) => {
    return {
      textDecoration: 'underline',
      color: color
        ? color
        : getTokenFromVibrant(
            globalThemeVariant === 'default'
              ? getTheme(theme).default.heading.textColor
              : getTheme(theme).secondary.heading.textColor,
            input.theme,
          ),
    };
  });

  return (
    <HStack justify="center">
      <a
        data-featured-vendor-link
        href={url}
        target="_blank"
        css={linkStyles}
        rel="noreferrer"
      >
        {t('contact_us_link_text')}
      </a>
    </HStack>
  );
}
